import { createContext, useContext, useState, useCallback } from "react";

export type SubMenuKey =
  | "insights"
  | "insightsV2"
  | "socialListening"
  | "socialListeningV2"
  | "inboxV2"
  | "brandKits"
  | "approvals"
  | null;

interface SubMenuContextValue {
  openedSubMenu: SubMenuKey;
  setOpenedSubMenu: (key: SubMenuKey) => void;
  toggleSubMenu: (key: SubMenuKey) => void;
}

const SubMenuContext = createContext<SubMenuContextValue | undefined>(
  undefined
);

export function SubMenuProvider({ children }: { children: React.ReactNode }) {
  const [openedSubMenu, setOpenedSubMenu] = useState<SubMenuKey>(null);

  const toggleSubMenu = useCallback((key: SubMenuKey) => {
    setOpenedSubMenu((current) => (current === key ? null : key));
  }, []);

  return (
    <SubMenuContext.Provider
      value={{ openedSubMenu, setOpenedSubMenu, toggleSubMenu }}
    >
      {children}
    </SubMenuContext.Provider>
  );
}

export function useSubMenuContext() {
  const context = useContext(SubMenuContext);
  if (!context) {
    throw new Error("useSubMenuContext must be used within SubMenuProvider");
  }
  return context;
}
